import React from 'react';
import { cn } from '../../lib/utils';
import { useThemeStore } from '../../store/theme';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ children, className }) => {
  const {
    isDark,
    glassOpacity,
    borderOpacity,
    cardStyle,
    roundedCorners,
    enableBlur,
  } = useThemeStore();

  const roundedStyles = {
    none: '',
    small: 'rounded',
    medium: 'rounded-lg',
    large: 'rounded-xl',
    full: 'rounded-3xl',
  };

  const getCardStyle = () => {
    switch (cardStyle) {
      case 'glass':
        return {
          backgroundColor: `rgba(${isDark ? '0, 0, 0' : '255, 255, 255'}, ${glassOpacity})`,
          backdropFilter: enableBlur ? 'blur(8px)' : undefined,
          borderWidth: '1px',
          borderColor: `rgba(0, 255, 242, ${borderOpacity})`,
        };
      case 'solid':
        return {
          backgroundColor: isDark ? 'rgba(24, 24, 27, 0.9)' : 'rgba(255, 255, 255, 0.9)',
          borderWidth: '1px',
          borderColor: isDark ? 'rgba(63, 63, 70, 0.4)' : 'rgba(228, 228, 231, 0.4)',
        };
      case 'minimal':
        return {
          backgroundColor: 'transparent',
          borderWidth: '1px',
          borderColor: isDark ? 'rgba(63, 63, 70, 0.2)' : 'rgba(228, 228, 231, 0.2)',
        };
    }
  };

  return (
    <div
      className={cn('p-6 transition-all duration-200', roundedStyles[roundedCorners], className)}
      style={getCardStyle()}
    >
      {children}
    </div>
  );
};